<template>
  <div class="add-card-height">
    <div class="item_gallery">
      <a :href="product_url" ref="guess_list_a">
        <v-img-card
          :card_type="card_type"
          :data_url="imageData.url"
          :data_src="imageData.thumbnail"
        ></v-img-card>
        <v-discount-tag
          v-if="show_discount_label && (1-variants.price/variants.regular_price) > 0.01"
          :variants="variants"
          :discount_label_color="discount_label_color"/>
      </a>
    </div>
    <!--商品名称-->
    <div class="item_name" v-if="show_name">
      <a
        class="page_text_font"
        :href="product_url"
        :title="product.title || product.post_title"
        :class="show_one_line ? 'oneline' : ''"
      >
        {{ product.title || product.post_title }}
      </a>
    </div>

    <!--商品价格-->
    <p class="item_price" v-if="show_product_price">
      <v-selectprice
        :price="variants.price"
        :font-size="fontSize ? fontSize : 14"
        :regular-font-size="regularFontSize ? regularFontSize : 14"
        :regular_price_num="
          variants.price - 0 < variants.regular_price - 0
            ? variants.regular_price
            : 0
        "
        style="pointer-events: none;"
        :disable_select="true"
        :country="!show_currency_selector ? '' : $store.state.pricetype"
      ></v-selectprice>
    </p>
    <!--商品评星-->
    <div class="item_star" v-if="show_start">
      <v-comments-star
        :disabled="true"
        :average_rating="product.average_rating || '0'"
        font_size="18"
      ></v-comments-star
      >({{ product.review_count }})
    </div>
    <div style="flex-grow: 1;/* height: 23px; */"></div>
    <!--商品加购按钮-->
    <div
      v-if="show_add_btn"
      class="item_addbtn"
      :style="variants.buy_able ? '' : 'cursor: no-drop !important'"
    >
      <button
        v-if="isPC"
        class="item_button"
        :class="[variants.buy_able ? 'transition-main' : 'slodout']"
        @click="variants.buy_able && add_cart(addproduct, variants)"
      >
        <span class="secondary_title text-uppercase">
          {{
            variants.buy_able
              ? $t("recommend.add_to_cart")
              : $t("detail.sold_out")
          }}
        </span>
      </button>
      <button
        v-else
        class="item_button"
        :class="[variants.buy_able ? 'transition-main' : 'slodout']"
      >
        <a :href="product_url" style="text-decoration: none; color: inherit">
          <span class="secondary_title text-uppercase">
            {{
              variants.buy_able
                ? $t("recommend.add_to_cart")
                : $t("detail.sold_out")
            }}
          </span>
        </a>
      </button>
    </div>

    <!-- ins加购按钮 -->
    <div
        v-if="model == 'instagram' && button_title && button_title.length"
        class="item_addbtn"
        :style="product.buy_able ? '' : 'cursor: no-drop !important'"
    >
        <button
           v-if="isPC && product.variants && product.variants.length"
            class="item_button"
            :class="[!product.buy_able && 'slodout']"
            :style="product.buy_able&&{
                backgroundColor: background_color || '#fff',
                border: '1px solid' + background_color || '#fff'
            }"
            @click="product.buy_able && show_product_model(product)"
        >
            <a
                style="text-decoration: none; color: inherit"
                :style="{ color: text_color || '#000' }"
            >
                <span class="secondary_title ">

                  {{
                    product.buy_able
                      ? button_title
                      : $t("detail.sold_out")
                  }}
                </span>
            </a>
        </button>
        <button
            v-else
            class="item_button"
            :class="[!product.buy_able && 'slodout']"
            :style="product.buy_able&&{
                backgroundColor: background_color || '#fff',
                border: '1px solid' + background_color || '#fff'
            }"
            @click="product.buy_able && !(product.variants&&product.variants.length)? add_cart(addproduct, variants) : toProduct(product.buy_able, product_url)"
        >
            <a
                style="text-decoration: none; color: inherit"
                :style="{ color:  text_color || '#000' }"
             >
                <span class="secondary_title ">
                  {{
                    product.buy_able
                      ? button_title
                      : $t("detail.sold_out")
                  }}
                </span>
            </a>
        </button>
    </div>
    <!--商品规格选择-->
    <div
      v-if="
        show_add_btn && product.variants && product.variants.length > 1 && isPC
      "
      class="item_attribute"
    >
      <v-allOptionSelect
        v-if="select_style=='all'"
        :options="product.variants"
        :addproduct="[addproduct]"
        :index="0"
        :selectvariants="selectvariants"
      ></v-allOptionSelect>
      <v-itemOptionSelect
        v-if="product.variant_attrs.length > 0 && select_style=='item'"
        :variant_attrs="product.variant_attrs"
        :attrs="attrs"
        :variants="variants"
        :selectattribute="selectattribute"
      ></v-itemOptionSelect>
    </div>
  </div>
</template>
<script>
import vAllOptionSelect from "./allOptionSelect.vue";
import vImgCard from "../common/imgCard.vue";
import vItemOptionSelect from "./itemOptionSelect.vue"
import vAddCardSelect from "./addCardSelect.vue";
import vDiscountTag from "./discountTag.vue";
import vCommentsStar from '@/js/components/view/comments/commentsstar.vue'

export default {
  props: [
    "card_type",
    "show_name",
    "show_one_line",
    "show_tag",
    "show_add_btn",
    "product",
    "add_cart",
    "show_currency_selector",
    "show_start",
    "show_product_price",
    "fontSize",
    "regularFontSize",
    "url_search",
    "buy_able_class",
    "isPC",
    "select_style",
    "model",
    "button_title",
    "background_color",
    "text_color",
    "ins_variants",
    "show_product_model",
    "show_discount_label",
    "discount_label_color",
  ],
  data() {
    return {
      variants: {},
      addproduct: {
        quantity: "1",
        product_id: this.product.ID,
      },
      attrs: [],
      // 图片数据
      imageData: {},
      model_on_off:false
    };
  },
  computed: {
    product_url() {
      let url = null;
      let { path, public_url } = this.product;
      if (this.url_search) {
        url = (path || public_url) + this.url_search;
      } else {
        url = path || public_url;
      }
      return url;
    },
  },
  methods: {
    selectvariants() {
      if (this.product.variants) {
        this.product.variants.some((item) => {
          if (item.ID == this.addproduct.variant_id) {
            this.variants = item;
            return true;
          }
        });
      }
    },
    selectattribute(val) {
      let { variants } = this.product;
      this.attrs = val;
      val.forEach((el, index) => {
        variants = variants.filter(
          (item) => item.attrs[index].value === el.value
        );
      });
      if (variants.length > 0) {
        this.addproduct.variant_id = variants[0].ID;
        this.variants = variants[0];
      } else {
        let copyvariants = JSON.parse(JSON.stringify(this.variants));
        copyvariants.buy_able = false;
        this.variants = copyvariants;
      }
    },
    getVariants() {
      // let variants
      let { variants } = this.product;
      if (this.model=="instagram" && this.ins_variants && this.ins_variants.length){
        variants = this.ins_variants
      }

      //初始化状态，若有变种第一次变种为第一个
      if (variants && variants.length) {
        this.variants = variants[0];
        this.addproduct.variant_id = variants[0].ID;
        this.attrs = JSON.parse(JSON.stringify(variants[0].attrs));
      } else {
        //若无变种 则深拷贝商品
        let product = JSON.stringify(this.product);
        this.variants = JSON.parse(product);
      }

      // 图片数据，在配置变种时不设置变种图片，显示产品主图
      this.imageData = this.variants?.feature_image || this.product?.feature_image ||{}
    },

    // ins加购按钮 如果含有变种 点击按钮进入商品详情
    toProduct(buy_able, product_url){
      if(buy_able){
        window.open(product_url,"_self")
      }
    }
  },
  mounted() {
    this.getVariants();
  },
  components: {
    vAllOptionSelect,
    vImgCard,
    vAddCardSelect,
    vItemOptionSelect,
    vDiscountTag,
    vCommentsStar,
  },
};
</script>
<style scoped lang='scss'>
.add-card-height {
  display: inline-block;
  width: 100%;
  .item_gallery {
    width: 100%;
    position: relative;
    box-sizing: border-box;
    ::v-deep{
      .imgCard{
        >img{
          position: absolute;
          max-width: 100% !important;
          max-height: 100% !important;
          width: 100% !important;
          height: 100% !important;
          object-fit: contain;
          -o-object-fit: contain;
          display: block;
          top: 0;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    a {
      display: inline-block;
      width: 100%;
      span {
        position: absolute;
        right: 0;
        top: 0;
        padding: 6px 12px;
        color: #fff;
        font-size: 12px;
        line-height: 14px;
        text-align: center;
        z-index: 1;
        background: #333;
      }
    }
  }

  .item_name {
    margin: 0 auto;
    margin-top: 12px;
    width: 100%;
    a {
      display: inline-block;
      height: 40px;
      line-height: 20px;
      color: #666;
      font-size: 14px;
      text-decoration: none;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    .oneline {
      height: 24px;
      display: inline-block;
      width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
  .item_attribute {
    width: 100%;
    color: #737373;
    height: 24px;
    margin-top: 4px;
    .guesslike-select {
      width: 100%;
      height: 100%;
      border: 1px solid #dfdfdf;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding: 0 25px 0 10px;
      box-sizing: border-box;
      z-index: 1;
      position: relative;
      color: #737373;
      border-radius: 4px;
      outline: 0;
      appearance: none;
      -webkit-appearance: none;
      line-height: 1;
      background-color: transparent;
      option {
        max-width: 100%;
      }
    }
  }
  .has_select {
    position: relative;
    &::after {
      font-family: iconfont !important;
      -webkit-font-smoothing: antialiased;
      content: "\E63C";
      font-size: 14px;
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 999;
      pointer-events: none;
    }
  }
  .has_palette {
    height: unset !important;
    &::after {
      display: none;
    }
  }
  .item_price {
    text-align: center;
    margin: 0 auto;
    margin-top: 4px;
    padding: 0;
    .price {
      font-size: 14px;
      margin: 0 2px;
      font-weight: 700;
    }
    .regular_price {
      font-size: 14px;
      margin: 0 2px;
      text-decoration: line-through;
      color: rgb(123, 119, 130);
      display: inline-block;
    }
  }
  .item_star {
    -webkit-tap-highlight-color: transparent;
    height: 18px;
    display: inline-flex;
    justify-content: left;
    align-items: center;
    margin: 0 auto;
    margin-top: 4px;
  }
  .item_button {
    display: inline-block;
    line-height: 1;
    cursor: pointer;
    background: #fff;
    border: 1px solid #dcdfe6;
    -webkit-appearance: none;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    transition: 0.1s;
    font-weight: 500;
    border-radius: 4px;
    font-family: LatoRegular !important;
    color: rgba(0, 0, 0, 1);
    border-color: rgba(0, 0, 0, 1);
    background-color: rgba(255, 255, 255, 1);
    margin: 12px auto 0;
    padding: 10px 0;
    width: 100%;
    font-size: 14px;
  }
  .slodout {
    background-color: #969696 !important;
    border-color: #969696 !important;
    color: white !important;
    cursor: default !important;
  }
}

</style>
